import { cn } from "@app/lib/utils";
import { searchDrawerAtom } from "@design-system/atoms";
import { TextInput } from "@design-system/components/Form";
import { SubmitButton } from "@design-system/components/SubmitButton";
import { SearchIcon } from "@design-system/icons";
import { trans } from "@mongez/localization";
import { Form } from "@mongez/react-form";

export function SearchDrawer() {
  const opened = searchDrawerAtom.useOpened();

  return (
    <div
      className={cn(
        "z-60 bg-cinder absolute start-0 grid w-full grid-rows-[0fr] bg-white transition-all duration-500",
        opened && "grid-rows-[1fr]",
      )}
    >
      <div
        className={cn(
          "text-b overflow-hidden transition-all",
          opened && "py-8",
        )}
      >
        <div className="mx-auto w-[80%]">
          <Form className="flex items-center justify-between rounded-[3.125rem] border border-dark-blue border-opacity-35">
            <TextInput
              name="q"
              placeholder={trans("search")}
              classes={{
                input: "border-none h-full !py-5 shadow-none text-dark-blue text-xl",
              }}
            />
            <SubmitButton className="m-2 bg-transparent hover:bg-transparent">
              <SearchIcon color="#000000" />
            </SubmitButton>
          </Form>
        </div>
      </div>
    </div>
  );
}
